<script lang="ts">
  import { chart } from "svelte-apexcharts";
  import { Col } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import { Yearlrgrowth } from "../../../Data/Chart/Dashboard/Ecommerce/Chart";
  import { Morethanlastyear,Yearlygrowth} from "../../../utils/Constant/Constant";
</script>

<Col xl="12" class="des-xl-50 yearly-growth-sec">
  <Card cardBodyprops="p-0">
    <div class="header-top d-sm-flex justify-content-between align-items-center" slot="customheader" >
        <h5>{Yearlygrowth}</h5>
        <div class="center-content">
        <p class="d-sm-flex align-items-center">
          <span class="m-r-10"
            ><i class="toprightarrow-primary fa fa-arrow-up m-r-10" />$9657.55k
          </span>86% {Morethanlastyear}
        </p>
      </div>
    </div>
    <div slot="contentbody">
      <div id="chart-yearly-growth-dash-2">
        <div use:chart={Yearlrgrowth} />
      </div>
    </div>
  </Card>
</Col>